import Immutable from 'seamless-immutable';
import createReducer from '../../../helpers/createReducer';

/**
 * Help store
 */
const state = {
  helpItems: [],
  fromHelp: false,
  damagedCartFormData: {},
};

/**
 * Help reducers
 */
const help = createReducer(state, {
  SET_FROM_HELP: (state, { data }) => Immutable({ ...state, fromHelp: data }),
  SET_HELP_ITEMS: (state, { data }) => Immutable({ ...state, helpItems: data }),
  SET_HELP_DAMAGED_CART_DATA: (state, { data }) => Immutable({
    ...state,
    damagedCartFormData: data
  }),
});

export default help;
